// extracted by mini-css-extract-plugin
export var dropdownContainer = "_s0-0";
export var leftAlign = "_s0-4";
export var listItem = "_s0-2";
export var listItemWrapper = "_s0-1";
export var operationText = "_s0-3";